module.exports = __webpack_public_path__ + "static/media/6.cb1e8cfd.png";